module.exports = __webpack_public_path__ + "img/check.b16489f6.svg";